/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { addNewOperation, updateOperation } from '../../../../../Redux/operations/operationsSlice'
import AttachementContent from './AttachementContent'
import { useTranslation } from 'react-i18next'

const index = ({ data, close }) => {
  const { t } = useTranslation() || ((text) => text)
  const { patientId, operations, selectedOpId } = data || {}
  const { patients } = useSelector((state) => state.patients)
  const { attachements } = patients.find((pt) => pt.id === patientId) || {
    attachements: []
  }
  const [selectedOperation, setSelectedOperation] = useState(operations?.find((op) => op.init_date === selectedOpId) || {})
  const changeOp = (operation) => {
    setSelectedOperation(operation)
  }
  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.popup_header}>
        <h2>{t('attachments_management')}</h2>
      </div>
      <div className={styles.popup_body}>
        <ul className={styles.side_navigator}>
          <li
            className={styles.side_navigator_item_main}
            onClick={() => {
              // close()
            }}
          >
            {t('operations')}
          </li>
          {operations?.map((op) => (
            <li
              key={op.init_date}
              className={`${styles.side_navigator_item} ${selectedOperation.init_date === op.init_date ? styles.active_op : ''}`}
              onClick={() => {
                changeOp(op)
              }}
            >
              {op.op_name}
            </li>
          ))}
        </ul>
        <div className={styles.main_body_content}>
          <AttachementContent t={t} patientId={patientId} attachements={attachements} selectedOperation={selectedOperation} />
        </div>
      </div>
    </div>
  )
}
export default index
